export default __webpack_public_path__ + "img/4d52a37a65b2f4107bac1a582d32c1ba.svg";